export interface InterfaceState {
  activeItem: ActiveItem;
  laserPointerActive: boolean;
  sidebarWidth: number;
  openRightSidebar: boolean;
}

export enum ActiveItem {
  POINTER = 'POINTER',
  TEXT = 'TEXT',
  FREE_HAND = 'FREE_HAND',
  LINE = 'LINE',
  STICKY_NOTES = 'STICKY_NOTES',
  UPLOAD_BOX = 'UPLOAD_BOX',
  ERASER = 'ERASER',
}

/* ACTIONS */

export enum InterfaceActionsKeys {
  CHANGE_ACTIVE_ITEM = 'CHANGE_ACTIVE_ITEM',
  CHANGE_LASER_ACTIVE = 'CHANGE_LASER_ACTIVE',
  CHANGE_SIDEBAR_WIDTH = 'CHANGE_SIDEBAR_WIDTH',
  SET_RIGHT_SIDEBAR = 'SET_RIGHT_SIDEBAR',
  RESET_STATE = 'RESET_STATE',
}

export interface InterfaceActionsPayload {
  [InterfaceActionsKeys.CHANGE_ACTIVE_ITEM]: InterfaceState['activeItem'];
  [InterfaceActionsKeys.CHANGE_LASER_ACTIVE]: boolean;
  [InterfaceActionsKeys.CHANGE_SIDEBAR_WIDTH]: number;
  [InterfaceActionsKeys.SET_RIGHT_SIDEBAR]: boolean;
  [InterfaceActionsKeys.RESET_STATE]: void;
}

/* MUTATIONS */

export enum InterfaceMutationsKeys {
  CHANGE_ACTIVE_ITEM = 'CHANGE_ACTIVE_ITEM',
  CHANGE_LASER_ACTIVE = 'CHANGE_LASER_ACTIVE',
  INTERFACE_RESET_STATE = 'INTERFACE_RESET_STATE',
  CHANGE_SIDEBAR_WIDTH = 'CHANGE_SIDEBAR_WIDTH',
  SET_RIGHT_SIDEBAR = 'SET_RIGHT_SIDEBAR',
}

export interface InterfaceMutationsPayload {
  [InterfaceMutationsKeys.CHANGE_ACTIVE_ITEM]: InterfaceState['activeItem'];
  [InterfaceMutationsKeys.CHANGE_LASER_ACTIVE]: boolean;
  [InterfaceMutationsKeys.CHANGE_SIDEBAR_WIDTH]: number;
  [InterfaceMutationsKeys.SET_RIGHT_SIDEBAR]: boolean;
  [InterfaceMutationsKeys.INTERFACE_RESET_STATE]: void;
}

/* GETTERS */

export enum InterfaceGettersKeys {
  interfaceActiveItem = 'interfaceActiveItem',
  interfaceLaserActive = 'interfaceLaserActive',
  sidebarWidth = 'sidebarWidth',
  openRightSidebar = 'openRightSidebar',
}

export interface InterfaceGettersReturns {
  [InterfaceGettersKeys.interfaceActiveItem]: InterfaceState['activeItem'];
  [InterfaceGettersKeys.interfaceLaserActive]: boolean;
  [InterfaceGettersKeys.sidebarWidth]: number;
  [InterfaceGettersKeys.openRightSidebar]: boolean;
}
